import { type Movie, type Screen, ScreenType, type Tv } from '@tmdb-graphql-api/schema/types';
import { type TileItem } from '../components/Tile/types.ts';
import { ImageSize, PosterSize } from '../enums/imageSizes.ts';
import { SectionType } from '../enums/mediaTypes.ts';
import { type Config } from '../types.ts';
import { buildImagePath } from './buildImagePath.ts';

export const formatMovie = (data: Movie, { images }: Config): TileItem => ({
  id: data.id,
  src: buildImagePath(data.posterPath, ImageSize.Poster, PosterSize.SM, images),
  status: data.status,
  title: data.title,
  type: SectionType.Movie,
  voteAverage: data.voteAverage,
});

export const formatTv = (data: Tv, { images }: Config): TileItem => ({
  id: data.id,
  src: buildImagePath(data.posterPath, ImageSize.Poster, PosterSize.SM, images),
  status: data.status,
  title: data.name,
  type: SectionType.Tv,
  voteAverage: data.voteAverage,
});

const isMovie = (listing: Screen | undefined, type: ScreenType): listing is Movie =>
  !!listing && type === ScreenType.Movie;

const isTv = (listing: Screen | undefined, type: ScreenType): listing is Tv => !!listing && type === ScreenType.Tv;

export const formatMoviesAndTvResults = (listings: Screen[], type: ScreenType, config: Config) =>
  listings.reduce((acc: TileItem[], data) => {
    if (isMovie(data, type)) {
      acc.push(formatMovie(data, config));
    } else if (isTv(data, type)) {
      acc.push(formatTv(data, config));
    }

    return acc;
  }, []);
